"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TickIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M9.707,17.548a.849.849,0,0,1-.6-.249L4.3,12.49l1.2-1.2L9.707,15.5,18.5,6.7l1.2,1.2-9.4,9.4A.848.848,0,0,1,9.707,17.548Z" })));
}
exports.default = TickIcon;
